export const inProgressPaths: { path: string; dashboard: string }[] = [
  { path: "/mx/meterread/smartmeter", dashboard: "/mx/dashboard" },
  {
    path: "/reports-analytics",
    dashboard: "/onboarding/system-admin/dashboard",
  },
  {
    path: "/integration-hub",
    dashboard: "/onboarding/system-admin/dashboard",
  },
  {
    path: "/admin",
    dashboard: "/onboarding/system-admin/dashboard",
  },
  {
    path: "/asset-management",
    dashboard: "/onboarding/system-admin/dashboard",
  },

  {
    path: "/ax/asset/plants",
    dashboard: "/onboarding/system-admin/dashboard",
  },

  {
    path: "/ax/asset/units",
    dashboard: "/onboarding/system-admin/dashboard",
  },

  {
    path: "/ax/asset/asset-library",
    dashboard: "/onboarding/system-admin/dashboard",
  },
  {
    path:"/cx/consumer-management/create/ai-upload",
    dashboard: "/cx/dashboard",
  },
  {
    path: "/ax/monitor/condition-index",
    dashboard: "/onboarding/system-admin/dashboard",
  },

  {
    path: "/ax/monitor/risk-analysis",
    dashboard: "/onboarding/system-admin/dashboard",
  },

  {
    path: "/ax/monitor/gis",
    dashboard: "/onboarding/system-admin/dashboard",
  },
  {
    path: "/integrations/payment",
    dashboard: "/onboarding/system-admin/dashboard",
  },
  {
    path: "/integrations/smart-meter",
    dashboard: "/onboarding/system-admin/dashboard",
  },
  {
    path: "/integration-hub/admin",
    dashboard: "/onboarding/system-admin/dashboard",
  },
];
